import { render, staticRenderFns } from "./dr-date-edit-component.vue?vue&type=template&id=4dae3a8a"
import script from "./dr-date-edit-component.vue?vue&type=script&lang=js"
export * from "./dr-date-edit-component.vue?vue&type=script&lang=js"
import style0 from "./dr-date-edit-component.vue?vue&type=style&index=0&id=4dae3a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports